import moment from 'moment';

const DISMISSAL_HOURS = 24;

// A closed popup stays hidden for a day, unless its image has been replaced in
// the admin since then, so a new offer still reaches visitors who closed the
// previous one. Visitors who closed a popup before the image was remembered
// have no stored image, so they see the current one once as well.
export const isPopupDismissed = (popupName: string, image: string): boolean => {
  const closedAt = localStorage.getItem(`${popupName}ClosedAt`);
  const closedImage = localStorage.getItem(`${popupName}ClosedImage`);

  if (!closedAt || closedImage !== image) {
    return false;
  }

  const closedFor = moment.duration(moment().diff(moment(closedAt)));

  return closedFor.asHours() < DISMISSAL_HOURS;
};

export const dismissPopup = (popupName: string, image: string) => {
  localStorage.setItem(`${popupName}ClosedAt`, moment().toString());
  localStorage.setItem(`${popupName}ClosedImage`, image);
};
